import { Column, ColumnType } from '@scale/compass-shared/types';
import { CompassCardUI } from '@scale/compass-ui/types';
import {
  ArchieQCResultsAdapterCardShared,
  type ArchieQCResultsAdapterContext,
  type ArchieQCResultsAdapterContextSchemaType,
  ARCHIE_QC_RESULTS_ADAPTER,
  type ArchieQCResultsFilter,
  ArchieQCJoinType,
  ArchieQCViewType,
} from '@scale/genai-compass-shared/cards/archie_qc_results_adapter';
import { faQrcode } from '@fortawesome/pro-solid-svg-icons';
import ArchieQCResultsAdapterCardComponent from './ArchieQCResultsAdapterCardComponent';

export const DEFAULT_ARCHIE_QC_RESULTS_LIMIT = 200;
export const DEFAULT_ARCHIE_QC_JOIN_TYPE: ArchieQCJoinType = ArchieQCJoinType.LEFT;
export const DEFAULT_ARCHIE_QC_VIEW_TYPE: ArchieQCViewType = ArchieQCViewType.ATTEMPT_BREAKDOWN;

/** Input columns for Archie QC Results Adapter filtering. */
export const ARCHIE_QC_RESULTS_ADAPTER_COLUMNS: Record<
  string,
  Column & { id: keyof ArchieQCResultsFilter }
> = {
  taxonomy: {
    id: 'taxonomy',
    header: 'Taxonomy',
    type: ColumnType.TEXT,
  },
  criteria: {
    id: 'criteria',
    header: 'Criteria',
    type: ColumnType.TEXT,
  },
};

const defaultContext: ArchieQCResultsAdapterContext = {
  cardType: ARCHIE_QC_RESULTS_ADAPTER,
  projectId: '',
  filter: {
    operator: 'and',
    filtersOrFilterGroups: [],
  },
  resultsLimit: DEFAULT_ARCHIE_QC_RESULTS_LIMIT,
  joinType: DEFAULT_ARCHIE_QC_JOIN_TYPE,
  viewType: DEFAULT_ARCHIE_QC_VIEW_TYPE,
};

export const ArchieQCResultsAdapterCardInfo: CompassCardUI<ArchieQCResultsAdapterContextSchemaType> =
  {
    ...ArchieQCResultsAdapterCardShared,
    title: 'Archie QC Results',
    icon: 'list',
    toolTip: 'Fetch Archie QC results for your project.',
    defaultContext,
    ownerTeam: 'Quality',
    legacyComponent: ArchieQCResultsAdapterCardComponent,
    button: {
      icon: faQrcode,
    },
  };
